import { render, staticRenderFns } from "./MenuGrouped.vue?vue&type=template&id=14244f09&scoped=true&"
import script from "./MenuGrouped.vue?vue&type=script&lang=js&"
export * from "./MenuGrouped.vue?vue&type=script&lang=js&"
import style0 from "./MenuGrouped.vue?vue&type=style&index=0&id=14244f09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14244f09",
  null
  
)

export default component.exports